module.exports = __webpack_public_path__ + "img/img-2-5mobile.b87efc7c.png";